import {
  MenuListProps,
  SahinDrawer,
} from '@sahinyazilim/sahinyazilim-components';
import { useAppSelector } from 'common/context/hooks';
import { createLink as createLinkHelper } from 'common/helper/createRoute';
import { AdminRouteNames } from 'common/model/AdminRouteNames';
import { OwnerEnv } from 'common/utils/env';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { menuList } from './Drawer.types';

export const Drawer = ({ children }: any) => {
  const navigate = useNavigate();
  const { branchId } = useParams<{ branchId: string }>();
  const currentPlan = useAppSelector((state) => state.common.currentPlan);
  const newOrderCount =
    useAppSelector((state) => state.order.newOrderCount) || 0;

  const onClickLogo = () => {
    navigate(createLinkHelper(AdminRouteNames, AdminRouteNames.HOME, branchId));
  };

  const list = useCallback(
    ({ ...args }: MenuListProps) => {
      return menuList({
        ...args,
        navigate,
        currentPlan,
        newOrderCount,
        branchId,
      });
    },
    [navigate, currentPlan, newOrderCount, branchId],
  );

  return (
    <SahinDrawer
      title={OwnerEnv.title as string}
      menuList={list}
      onClickLogo={onClickLogo}
    >
      {children}
    </SahinDrawer>
  );
};
